<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="500"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          dark
          color="indigo"
          style="width:250px;"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon left>
            mdi-card-account-details-outline
          </v-icon>
          <span>Ajouter un badge</span>
        </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2">
          Badge
        </v-card-title>

        <v-card-text>
          <user-form
            @userFormSent="handleUserForm"
          ></user-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UserForm from './UserForm.vue';

export default {
  components: {
    UserForm,
  },
  data() {
    return {
      dialog: false,
    };
  },
  methods: {
    handleUserForm(res) {
      console.log('handleUserForm res: ', res);
      this.dialog = false;
      this.$emit('refresh');
    },
  },
};
</script>

<style scoped>
.super-class {
  background: #4b79b6;
}
</style>
